// extracted by mini-css-extract-plugin
export var content = "_7p-3";
export var list = "_7p-4";
export var settingsContent = "_7p-7";
export var settingsPanel = "_7p-8";
export var state = "_7p-6";
export var triggerBadge = "_7p-2";
export var triggerButton = "_7p-1";
export var triggerShell = "_7p-0";
export var unreadDot = "_7p-5";